import { Box, type BoxProps } from '@mantine/core';
import { usePixiSpineAnimation } from '../hooks/usePixiSpineAnimation.hook';

export type CashoutAnimationRendererProps = BoxProps;

export const CashoutAnimationRenderer = ({
  style,
  ...props
}: CashoutAnimationRendererProps) => {
  const { containerRef } = usePixiSpineAnimation({
    jsonUrl: '/spine/coins/skeleton.json',
    atlasUrl: '/spine/coins/coins-all.atlas',
    animationName: 'coins',
    scale: 0.2,
    speed: 1.5,
  });

  return (
    <Box
      data-test-id="cashout-animation"
      ref={containerRef}
      style={{
        position: 'absolute',
        right: 0,
        top: 0,
        zIndex: 10,
        width: 400,
        height: 600,
        ...style,
      }}
      {...props}
    />
  );
};
